import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { changeSeason } from 'common/store/modules/competition-nav/thunks';

export const SeasonNavItem = ({
    seasons,
    hideLabel = false,
    removeFinals = false
}) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    if (!seasons.find((s) => s.id === Number(nav.season.id)) && seasons) {
        return '';
    }

    const selectedItemToString = (item) => item?.name.split(' ')[0];

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={seasons}
                itemToString={(season) => season.name}
                selectedItemToString={selectedItemToString}
                type="with-default"
                {...(hideLabel && {
                    icon: 'season-trophy'
                })}
                initialSelectedItem={
                    seasons && nav.season.id
                        ? seasons.find((s) => s.id === Number(nav.season.id))
                        : ''
                }
                activeItem={
                    seasons && nav.season.id
                        ? seasons.find((s) => s.id === Number(nav.season.id))
                        : ''
                }
                isReadyToRender={() => seasons?.length && Number(nav.season.id)}
                label={getTranslation('label.stats.season')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        changeSeason({
                            season: selectedItem,
                            removeFinals
                        })
                    );
                }}
                hideLabel={hideLabel}
            />
        </div>
    );
};

SeasonNavItem.propTypes = {
    seasons: PropTypes.array,
    title: PropTypes.string,
    hideLabel: PropTypes.bool,
    removeFinals: PropTypes.bool
};
